import axios from "axios";
import moment from "moment";
import jwt_decode from "jwt-decode";
import Ingiunzione from "../../../common/mookup/mookupIngiunzione";
import {logOut} from "../../../common/utils"
import { toast } from "react-toastify";

 class DetailIngiunzioneService {
    getDetailIngiunzione(onSuccess) {
       onSuccess(Ingiunzione)
      }


      getDettaglioIngiunzione(idIngiunzione, onSuccess){  
         let host = process.env.REACT_APP_API_URL;
         var objUser = JSON.parse(sessionStorage.getItem('user'));
         var decoded = jwt_decode(objUser.token);
         const configHeaders = {
             headers: {  
                 'Authorization': 'Bearer '+objUser.token,
                 'CF': decoded.CFA,
                 'Content-Type': 'application/json',
                 'Access-Control-Allow-Origin' : '*',
                 'Access-Control-Allow-Headers' : 'Origin, X-Requested-With, Content-Type, Accept',
                 'Access-Control-Allow-Methods' : 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
                 }
             };
             axios.get(host+"/api/v1/ingiunzioni/dettagliIngiunzione/" + idIngiunzione, configHeaders).then(function(result){
              if(result.status === 401){
                logOut();
              }
               onSuccess(result.data);
             }, function(error){
              if(error.response.status === 401){
                logOut();
              }
                 console.log("errore "+error);
                 onSuccess();
             });
       }
       getListStatiSanzione(idSanzione, onSuccess) {
         let host = process.env.REACT_APP_API_URL;
         var objUser = JSON.parse(sessionStorage.getItem("user"));
         var decoded = jwt_decode(objUser.token);
         const configHeaders = {
           headers: {
             Authorization: "Bearer " + objUser.token,
             CF: decoded.CFA,
             "Content-Type": "application/json",
             "Access-Control-Allow-Origin": "*",
             "Access-Control-Allow-Headers":
               "Origin, X-Requested-With, Content-Type, Accept",
             "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
           },
         };
         axios
           .get(host + "/api/v1/storico/sanzione/find/" + idSanzione, configHeaders)
           .then(
             function (result) {
              if(result.status === 401){
                logOut();
              }
               onSuccess(result.data);
             },
             function (error) {
              if(error.response.status === 401){
                logOut();
              }
               console.log(
                 "errore " + error
               );
               onSuccess([]);
             }
           );
       }
       getRecidivo(CF, onSuccess) {
         let host = process.env.REACT_APP_API_URL;
         var objUser = JSON.parse(sessionStorage.getItem("user"));
         var decoded = jwt_decode(objUser.token);
         const configHeaders = {
           headers: {
             Authorization: "Bearer " + objUser.token,
             CF: decoded.CFA,
             "Content-Type": "application/json",
             "Access-Control-Allow-Origin": "*",
             "Access-Control-Allow-Headers":
               "Origin, X-Requested-With, Content-Type, Accept",
             "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
           },
         };
         axios
           .get(
             host + `/api/v1/recidivi/find/${CF}`,
             configHeaders
           )
           .then(
             function (result) {
              if(result.status === 401){
                logOut();
              }
               onSuccess(result);
             },
             function (error) {
              if(error.response.status === 401){
                logOut();
              }
               console.log("errore  " + error);
               onSuccess();
             }
           );
       }

       getDetailSanzione(idSanzione, onSuccess) {
         let host = process.env.REACT_APP_API_URL;
         var objUser = JSON.parse(sessionStorage.getItem("user"));
         var decoded = jwt_decode(objUser.token);
         const configHeaders = {
           headers: {
             Authorization: "Bearer " + objUser.token,
             CF: decoded.CFA,
             "Content-Type": "application/json",
             "Access-Control-Allow-Origin": "*",
             "Access-Control-Allow-Headers":
               "Origin, X-Requested-With, Content-Type, Accept",
             "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
           },
         };
         axios
           .get(host + "/api/v1/sanzione/detail/" + idSanzione, configHeaders)
           .then(
             function (result) {
              if(result.status === 401){
                logOut();
              }
               onSuccess(result.data);
             },
             function (error) {
              if(error.response.status === 401){
                logOut();
              }
               console.log("errore  " + error);
               onSuccess("");
             }
           );
       }

       getRicevutaPagamento(id,numeroRata,onSuccess,onError){
        let host = process.env.REACT_APP_API_URL;
        var objUser = JSON.parse(sessionStorage.getItem("user"));
        var decoded = jwt_decode(objUser.token);
        const configHeaders = {
          headers: {
            Authorization: "Bearer " + objUser.token,
            CF: decoded.CFA,
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Headers":
              "Origin, X-Requested-With, Content-Type, Accept",
            "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          },
        };
    
        axios.get(host + `/api/v1/sanzione/ricevuta/${id}/${numeroRata}`,configHeaders)
        .then(
          function (result){
            if(result.status === 200){
              onSuccess(result.data);
            }else if(result.status === 401){
              logOut();
            }else{
              onError();
            }
          },
          function (error) {
            onError();
          }
        )
      }

       getStoricoPagamenti(id,onSuccess,onError){
        let host = process.env.REACT_APP_API_URL;
        var objUser = JSON.parse(sessionStorage.getItem("user"));
        var decoded = jwt_decode(objUser.token);
        const configHeaders = {
          headers: {
            Authorization: "Bearer " + objUser.token,
            CF: decoded.CFA,
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Headers":
              "Origin, X-Requested-With, Content-Type, Accept",
            "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          },
        };
    
        axios.get(host + "/api/v1/sanzione/getStorico/" + id,configHeaders)
        .then(
          function (result){
            if(result.status === 200){
              onSuccess(result.data);
            }else if(result.status === 401){
              logOut();
            }else{
              onError();
            }
          },
          function (error) {
            onError();
          }
        )
      }


       avanzaStatoPerDiverseAzioni(oggettoSaznioneCompleto, idSanzione, idStatoTo, onSuccess, onError){
        let host = process.env.REACT_APP_API_URL;
        var objUser = JSON.parse(sessionStorage.getItem("user"));
        var decoded = jwt_decode(objUser.token);
        const configHeaders = {
          headers: {
            Authorization: "Bearer " + objUser.token,
            CF: decoded.CFA,
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Headers":
              "Origin, X-Requested-With, Content-Type, Accept",
            "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          },
        };
        // const request = new Object();
        // request.sanzioni = oggettoSaznioneCompleto;
        // oggettoSaznioneCompleto.listaStatiTo = {
        //   idStato:idStatoTo,
        //   nomeStato:"Validato"
        // }
        // console.log(oggettoSaznioneCompleto)
        axios
          .put(
            host + "/api/v1/ingiunzioni/changeStato/" + idSanzione + "/" +idStatoTo,
            oggettoSaznioneCompleto,//Oggetto Completo
            configHeaders
          )
          .then(
            function (result) {
              if(result.status === 401){
                logOut();
              }
              onSuccess(result.data);
            },
            function (error) {
              if(error.response.status === 401){
                logOut();
              }else{
                if(onError){
                  onError()
                }
              }
              toast.error(error.response.data !== "" ? error.response.data : "Errore riprova piu tardi", {
                position: toast.POSITION.TOP_RIGHT,
              });
            }
          );
      }

      AgliAttiPerLoscrittoDifensivo(sanzione, note, idSaznione, idStato, onSuccess) {
        // sanzione.dataDiEmissione = moment(sanzione.dataDiEmissione, "DD/MM/YYYY")
        //   .toDate()
        //   .getTime();
        // if (sanzione.anagraficaTrasgressore.dataDiNascita)
        //   sanzione.anagraficaTrasgressore.dataDiNascita = moment(
        //     sanzione.anagraficaTrasgressore.dataDiNascita,
        //     "DD/MM/YYYY"
        //   )
        //     .toDate()
        //     .getTime();
        // if (sanzione.anagraficaTrasgressore.dataRilascioDocumento)
        //   sanzione.anagraficaTrasgressore.dataRilascioDocumento = moment(
        //     sanzione.anagraficaTrasgressore.dataRilascioDocumento,
        //     "DD/MM/YYYY"
        //   )
        //     .toDate()
        //     .getTime();
        // if (sanzione.anagraficaTrasgressore.isMinorenne)
        //   sanzione.anagraficaTrasgressore.isMinorenne = 1;
        // else sanzione.anagraficaTrasgressore.isMinorenne = 0;
        // if (sanzione.anagraficaPotestaTrasgressore.dataDiNascita)
        //   sanzione.anagraficaPotestaTrasgressore.dataDiNascita = moment(
        //     sanzione.anagraficaPotestaTrasgressore.dataDiNascita,
        //     "DD/MM/YYYY"
        //   )
        //     .toDate()
        //     .getTime();
        // if (sanzione.anagraficaPotestaTrasgressore.dataRilascioDocumento)
        //   sanzione.anagraficaPotestaTrasgressore.dataRilascioDocumento = moment(
        //     sanzione.anagraficaPotestaTrasgressore.dataRilascioDocumento,
        //     "DD/MM/YYYY"
        //   )
        //     .toDate()
        //     .getTime();
        // if (sanzione.anagraficaPotestaTrasgressore.isMinorenne)
        //   sanzione.anagraficaPotestaTrasgressore.isMinorenne = 1;
        // else sanzione.anagraficaPotestaTrasgressore.isMinorenne = 0;
    
        // if (sanzione.isverbaleFattoABordo) sanzione.isverbaleFattoABordo = 1;
        // else sanzione.isverbaleFattoABordo = 0;
    
        const request = new Object();
        request.sanzioni = sanzione;
        request.motivazione = note;
        request.stato = "Agli Atti";
        request.importo = 0;
        let host = process.env.REACT_APP_API_URL;
        var objUser = JSON.parse(sessionStorage.getItem("user"));
        var decoded = jwt_decode(objUser.token);
        const configHeaders = {
          headers: {
            Authorization: "Bearer " + objUser.token,
            CF: decoded.CFA,
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Headers":
              "Origin, X-Requested-With, Content-Type, Accept",
            "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          },
        };
        this.avanzaStatoPerDiverseAzioni(sanzione,idSaznione,idStato,onSuccess)
        // axios
        //   .put(
        //     host + "/api/v1/sanzione/avanzaStato/altriStati",
        //     request,
        //     configHeaders
        //   )
        //   .then(
        //     function (result) {
        //       onSuccess(result.data);
        //     },
        //     function (error) {
        //       console.log("errore ricerca dettaglio sanzione " + error);
        //       onSuccess("");
        //     }
        //   );
      }

      pagaSanzioneORata(PagaSaznione,idSaznione, idStato, onSuccess,onError) {
        let host = process.env.REACT_APP_API_URL;
        var objUser = JSON.parse(sessionStorage.getItem("user"));
        var decoded = jwt_decode(objUser.token);
        const configHeaders = {
          headers: {
            Authorization: "Bearer " + objUser.token,
            CF: decoded.CFA,
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Headers":
              "Origin, X-Requested-With, Content-Type, Accept",
            "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          },
        };
    
        this.avanzaStatoPerDiverseAzioni(PagaSaznione, idSaznione, idStato, onSuccess, onError)
    
        // axios
        //   .post(
        //     host + "/api/v1/sanzione/avanzaStato/pagata",
        //     PagaSaznione,
        //     configHeaders
        //   )
        //   .then(
        //     function (result) {
        //       onSuccess(result);
        //     },
        //     function (error) {
        //       console.log("errore ricerca dettaglio sanzione " + error);
        //       onSuccess("");
        //     }
        //   );
      }
    
      creaRateizza(sanzione,idSanzione, idSato, onSuccess) {
        let host = process.env.REACT_APP_API_URL;
        var objUser = JSON.parse(sessionStorage.getItem("user"));
        var decoded = jwt_decode(objUser.token);
        const configHeaders = {
          headers: {
            Authorization: "Bearer " + objUser.token,
            CF: decoded.CFA,
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Headers":
              "Origin, X-Requested-With, Content-Type, Accept",
            "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          },
        };
    
        this.avanzaStatoPerDiverseAzioni(sanzione, idSanzione, idSato, onSuccess)
        // axios
        //   .post(
        //     host + "/api/v1/sanzione/avanzaStato/rateizza",
        //     sanzione,
        //     configHeaders
        //   )
        //   .then(
        //     function (result) {
        //       onSuccess(result);
        //     },
        //     function (error) {
        //       console.log("errore ricerca dettaglio sanzione " + error);
        //       onSuccess("");
        //     }
        //   );
      }


      getDetailRata(IdSanzion, onSuccess) {
        let host = process.env.REACT_APP_API_URL;
        var objUser = JSON.parse(sessionStorage.getItem("user"));
        var decoded = jwt_decode(objUser.token);
        const configHeaders = {
          headers: {
            Authorization: "Bearer " + objUser.token,
            CF: decoded.CFA,
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Headers":
              "Origin, X-Requested-With, Content-Type, Accept",
            "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          },
        };
        axios
          .get(host + "/api/v1/sanzione/findRate/" + IdSanzion, configHeaders)
          .then(
            function (result) {
              if(result.status === 401){
                logOut();
              }
              onSuccess(result);
            },
            function (error) {
              if(error.response.status === 401){
                logOut();
              }
              console.log("errore ricerca dettaglio sanzione " + error);
              onSuccess("");
            }
          );
      }
      dettaglioDiUnPagameto(numeroSanzione, IdRata, onSuccess) {
        let host = process.env.REACT_APP_API_URL;
        var objUser = JSON.parse(sessionStorage.getItem("user"));
        var decoded = jwt_decode(objUser.token);
        const configHeaders = {
          headers: {
            Authorization: "Bearer " + objUser.token,
            CF: decoded.CFA,
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Headers":
              "Origin, X-Requested-With, Content-Type, Accept",
            "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          },
        };
        axios
          .get(
            host + "/api/v1/sanzione/findRate/" + numeroSanzione + "/" + IdRata,
            configHeaders
          )
          .then(
            function (result) {
              if(result.status === 401){
                logOut();
              }
              onSuccess(result);
            },
            function (error) {
              if(error.response.status === 401){
                logOut();
              }
              console.log("errore ricerca dettaglio sanzione " + error);
              onSuccess("");
            }
          );
      }
      impostazioniSpese(onSuccess) {
        var objUser = JSON.parse(sessionStorage.getItem("user"));
        var decoded = jwt_decode(objUser.token);
        let host = process.env.REACT_APP_API_URL;
        const configHeaders = {
          headers: {
            Authorization: "Bearer " + objUser.token,
            CF: decoded.CFA,
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Headers":
              "Origin, X-Requested-With, Content-Type, Accept",
            "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          }
        };
       axios.get(host+"/api/v1/impostazioni/find/imp", configHeaders).then(function(result){
          if(result.status === 401){
            logOut();
          }
            onSuccess(result.data);
        }, function(error){
         if(error.response.status === 401){
            logOut();
          }
            console.log("Errore di  "+error);
            onSuccess("");
        });
      }
}

export default DetailIngiunzioneService;